import type { ReadonlyDeep } from 'type-fest';

import { DocumentTemplateInput } from '@e-socna/data-layer';

import { documentForm2ApiMapper } from '../../../components/DocumentEditor/mappers/document.form2api.mapper';
import { codingConfigForm2ApiMapper } from '../../../forms/CodingConfig/mappers/coding-config.form2api.mapper';
import { pruneInput } from '../../../utils/prune-input.util';

import type { DocumentTemplatePage_OneDocumentTemplate } from '../../DocumentTemplate/hooks/useFindOneDocumentTemplateQuery.hook';

export function documentTemplateForm2ApiMapper(
  documentTemplate: ReadonlyDeep<DocumentTemplatePage_OneDocumentTemplate>,
) {
  const documentTemplateInput = pruneInput(
    documentTemplate,
    DocumentTemplateInput,
  );

  const codingConfigInput = codingConfigForm2ApiMapper(
    documentTemplate.codingConfig,
  );

  return {
    ...documentTemplateInput,
    document: {
      ...documentForm2ApiMapper(documentTemplate.document),
      codingConfig: codingConfigInput,
    },
    codingConfig: codingConfigInput,
  };
}
